require('../css/admin.css');

require('uploadcare-widget');
require('./WCProUploadCare');